<template>
  <div class="app_container">
    <van-divider content-position="left" :style="{ color: '#1989fa', borderColor: '#1989fa', fontWeight: 'bold' }">合同</van-divider>
    <van-cell center title="合同未归档逾期提醒">
      <template #right-icon>
        <van-switch :value="form.isFileSaveMsg" @input="onInput(form, 'isFileSaveMsg', 0)" :active-value="1" :inactive-value="0" size="24px" />
      </template>
    </van-cell>
    <van-cell center title="合同即将过期提醒">
      <template #right-icon>
        <van-switch :value="form.isContractExceTimeMsg" @input="onInput(form, 'isContractExceTimeMsg', 1)" :active-value="1" :inactive-value="0" size="24px" />
      </template>
    </van-cell>
    <van-cell center title="合同过期提醒">
      <template #right-icon>
        <van-switch :value="form.isContractExceedTimeMsg" @input="onInput(form, 'isContractExceedTimeMsg', 2)" :active-value="1" :inactive-value="0" size="24px" />
      </template>
    </van-cell>
    <van-divider content-position="left" :style="{ color: '#1989fa', borderColor: '#1989fa', fontWeight: 'bold' }">垫款</van-divider>
    <van-cell center title="垫款未回款逾期提醒">
      <template #right-icon>
        <van-switch :value="form.isAdvancesExceedTimeMsg" @input="onInput(form, 'isAdvancesExceedTimeMsg', 3)" :active-value="1" :inactive-value="0" size="24px" />
      </template>
    </van-cell>
    <van-divider content-position="left" :style="{ color: '#1989fa', borderColor: '#1989fa', fontWeight: 'bold' }">收款</van-divider>
    <van-cell center title="业务员回款未认领提醒">
      <template #right-icon>
        <van-switch :value="form.isIncomeNoGetMsg" @input="onInput(form, 'isIncomeNoGetMsg', 4)" :active-value="1" :inactive-value="0" size="24px" />
      </template>
    </van-cell>
    <van-divider content-position="left" :style="{ color: '#1989fa', borderColor: '#1989fa', fontWeight: 'bold' }">充值</van-divider>
    <van-cell center title="客户账户ID退款提醒">
      <template #right-icon>
        <van-switch :value="form.isAccountRefundMsg" @input="onInput(form, 'isAccountRefundMsg', 5)" :active-value="1" :inactive-value="0" size="24px" />
      </template>
    </van-cell>
    <van-cell center title="客户账户ID划拨提醒">
      <template #right-icon>
        <van-switch :value="form.isAccountTransferMsg" @input="onInput(form, 'isAccountTransferMsg', 6)" :active-value="1" :inactive-value="0" size="24px" />
      </template>
    </van-cell>
  </div>
</template>

<script>
import { getUserProfileNew, updateUserProfile } from '@/api/system/user'
import { Toast, Switch, Dialog } from 'vant'
export default {
  name: 'approve',
  components: {
    [Toast.name]: Toast,
    [Switch.name]: Switch,
    [Dialog.Component.name]: Dialog.Component
  },
  data() {
    return {
      form: {
        isFileSaveMsg: 0,
        isContractExceedTimeMsg: 0,
        isContractExceTimeMsg: 0,
        isAdvancesExceedTimeMsg: 0,
        isIncomeNoGetMsg: 0,
        isAccountRefundMsg: 0,
        isAccountTransferMsg: 0,
        userId: null
      },
      typeArr: ['合同未归档逾期提醒', '合同即将过期提醒', '合同过期提醒', '垫款未回款逾期提醒', '业务员回款未认领提醒', '客户账户ID退款提醒', '客户账户ID划拨提醒']
    }
  },
  mounted() {
    this.init()
    this.getInfo()
  },
  methods: {
    async init() {
      document.title = '提醒设置'
    },
    getInfo() {
      getUserProfileNew({ userId: this.$store.state.user.user.userId }).then(res => {
        if (res.code === 200) {
          this.form.isFileSaveMsg = res.data.isFileSaveMsg
          this.form.isContractExceedTimeMsg = res.data.isContractExceedTimeMsg
          this.form.isContractExceTimeMsg = res.data.isContractExceTimeMsg
          this.form.isAdvancesExceedTimeMsg = res.data.isAdvancesExceedTimeMsg
          this.form.isIncomeNoGetMsg = res.data.isIncomeNoGetMsg
          this.form.isAccountRefundMsg = res.data.isAccountRefundMsg
          this.form.isAccountTransferMsg = res.data.isAccountTransferMsg
          this.form.userId = res.data.userId
        }
      })
    },
    onInput(val, type, index) {
      const that = this
      const text = val[type] == 0 ? '开启' : '关闭'
      Dialog.confirm({
        title: '警告',
        message: '确认要"' + text + '""' + this.typeArr[index] + '"吗?'
      }).then(() => {
        this.form[type] = val[type] == 0 ? 1 : 0
        console.log(this.form)
        updateUserProfile(this.form).then(response => {
          if (response.code === 200) {
            Toast.success(text + '成功')
            setTimeout(() => {
              that.getInfo()
            }, 500)
          }
        })
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import url("@/style/index.less");
.app_container{
  background-color: #fff;
  padding: 20px 40px;
}
</style>
